export const createSingleton = <T>(factory: () => T): () => T => {
    let instance: T | null = null;

    return () => {
        instance ??= factory();
        return instance;
    };
};